module.exports = __webpack_public_path__ + "img/ep2-8.a371e0ed.png";